(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('WidgetModalCtrl', WidgetModalCtrl);

  WidgetModalCtrl.$inject = [
    'data'
  ];

  function WidgetModalCtrl(data) {
    const vm = this;
    vm.data = data;
  }
}());
